// @flow
import React, { useState } from 'react';
// Styles
import './SearchPage.css';
// Components
import {
  Configure,
  Pagination,
  Hits,
  Stats,
  connectStateResults,
  connectRefinementList,
} from 'react-instantsearch-dom';
import SearchNoResult from './SearchNoResult';
import { PageLoader, useScreenWidth, PageTitleWithGoBack } from '../../common';
import RefinementMenu from './RefinementMenu';
import SearchResultSquare from './SearchResultSquare';
import useDebouncedEffect from '../../current-order/customHooks/useDebouncedEffect';
import SortButton from './SortButton';

type Props = {
  query: string,
  searchResults: any,
  searchState: any,
  searching: boolean,
};

const VirtualRefinementList = connectRefinementList(() => null);

const anySales = searchResults => {
  const onSaleFacet = searchResults?.facets?.find(
    facet => facet.name === 'on_sale',
  );

  const onSaleCount = onSaleFacet?.data?.true ?? 0;

  return onSaleCount >= 1;
};

const SearchPage = ({
  query = '',
  searchResults,
  searchState,
  searching,
}: Props) => {
  const screenWidth = useScreenWidth();

  const subdepartmentSlug =
    searchState?.refinementList?.['subdepartments.name']?.[0];

  const isWildcardOrEmpty = !query || query.trim() === '*';
  const displayQuery = isWildcardOrEmpty
    ? ''
    : query.length > 40
      ? `${query.substring(0, 40)}...`
      : query;

  const pageTitle = displayQuery
    ? `Resultados para: "${displayQuery}"`
    : subdepartmentSlug
      ? subdepartmentSlug
      : 'Resultado da Pesquisa';

  const noResults = searchResults ? searchResults.nbHits === 0 : false;
  const [loading, setLoading] = useState(searching);

  useDebouncedEffect(
    signal => {
      if (!signal.aborted) {
        setLoading(searching);
      }
    },
    [searching],
    100,
  );

  return (
    <div className="search-page-main">
      <div className="search-page-header">
        <PageTitleWithGoBack title={pageTitle} />
        <div className="search-page-header-actions">
          <SortButton />

          {!noResults && searchResults && (
            <div className="search-page-stats-top">
              <Stats
                translate={(name, n, ms) =>
                  `${searchResults?.hits?.length} de ${n} resultados`
                }
              />
            </div>
          )}
        </div>
      </div>

      <Configure query={query} hitsPerPage={12} facets={['on_sale']} />
      <VirtualRefinementList attribute="departments.name" />
      <VirtualRefinementList attribute="subdepartments.name" />

      {loading ? <PageLoader text="Pesquisando..." /> : null}

      <div
        className={`search-page-container ${
          loading ? 'search-page-hidden' : ''
        }`}
      >
        {!noResults && (
          <RefinementMenu showSalesRefinement={anySales(searchResults)} />
        )}
        <div className="search-page-hits">
          <div>
            {noResults && <SearchNoResult />}
            {screenWidth <= 1090 ? (
              <section className="search-page-grid-mobile">
                <Hits hitComponent={SearchResultSquare} />
              </section>
            ) : (
              <section className="search-page-grid">
                <Hits hitComponent={SearchResultSquare} />
              </section>
            )}
          </div>

          <div className="search-page-footer">
            <Pagination padding={screenWidth > 768 ? 3 : 2} showLast={true} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default connectStateResults(SearchPage);
